export const modalSizes = { XS: 'xs', SM: 'sm', LG: 'lg', XL: 'xl', XXL: 'xxl', TALL: 'tall' } as const;

export type ModalSize = (typeof modalSizes)[keyof typeof modalSizes];

const defaultAspectRatio = 16 / 9;

interface ModalDimension {
  width: number;
  aspectRatio: number;
}

export const modalDimensions: Record<ModalSize, ModalDimension> = {
  [modalSizes.XS]: {
    width: 340,
    aspectRatio: defaultAspectRatio,
  },
  [modalSizes.SM]: {
    width: 400,
    aspectRatio: defaultAspectRatio,
  },
  [modalSizes.LG]: {
    width: 640,
    aspectRatio: defaultAspectRatio,
  },
  [modalSizes.XL]: {
    width: 889,
    aspectRatio: defaultAspectRatio,
  },
  [modalSizes.XXL]: {
    width: 1153,
    aspectRatio: defaultAspectRatio,
  },
  [modalSizes.TALL]: {
    width: 640,
    aspectRatio: 1,
  },
};
